(function () {
  var IDLE_MS    = 60000;
  var SCALE      = 3;             // 저해상도 배율 (클수록 빠름, 더 흐림)
  var SVG_ASPECT = 1758.42 / 1538.085;

  var overlay, canvas, ctx;
  var W, H, LW, LH;
  var t         = 0;
  var active    = false;
  var idleTimer = null;
  var raf       = null;
  var svgImg    = null;
  var svgReady  = false;
  var distField = null;

  // ── HSL → RGB ─────────────────────────────────────────────
  function h2r(p, q, h) {
    if (h < 0) h += 1; if (h > 1) h -= 1;
    if (h < 1/6) return p + (q-p)*6*h;
    if (h < 1/2) return q;
    if (h < 2/3) return p + (q-p)*(2/3-h)*6;
    return p;
  }
  function hsl(h, s, l) {
    var q = l < 0.5 ? l*(1+s) : l+s-l*s, p = 2*l-q;
    return [
      Math.round(h2r(p,q,h+1/3)*255),
      Math.round(h2r(p,q,h    )*255),
      Math.round(h2r(p,q,h-1/3)*255)
    ];
  }

  // ── SVG 경계선 기준 거리 필드 (BFS) ─────────────────────
  function buildDF() {
    var ofc  = document.createElement('canvas');
    ofc.width = LW; ofc.height = LH;
    var oc   = ofc.getContext('2d');

    var symW = Math.min(LW, LH) * 1.5;
    var symH = symW * SVG_ASPECT;
    oc.drawImage(svgImg, (LW-symW)/2, (LH-symH)/2, symW, symH);

    var px    = oc.getImageData(0, 0, LW, LH).data;
    var sym   = new Uint8Array(LW * LH);
    var dist  = new Float32Array(LW * LH).fill(Infinity);
    var queue = [];

    for (var i = 0; i < LW * LH; i++) {
      sym[i] = px[i*4+3] > 15 ? 1 : 0;
    }

    // 심볼 경계선(symbol ↔ empty 인접) 픽셀을 거리 0으로 시드
    for (var i = 0; i < LW * LH; i++) {
      if (!sym[i]) continue;
      var x = i % LW, y = (i / LW) | 0;
      if ((x > 0    && !sym[i-1])
       || (x < LW-1 && !sym[i+1])
       || (y > 0    && !sym[i-LW])
       || (y < LH-1 && !sym[i+LW])) {
        dist[i] = 0;
        queue.push(i);
      }
    }

    // BFS → 경계선에서 안팎으로 거리 전파
    var head = 0;
    while (head < queue.length) {
      var cur = queue[head++];
      var x = cur % LW, y = (cur / LW) | 0;
      var nd = dist[cur] + 1;
      var ns = [
        x > 0    ? cur-1  : -1,
        x < LW-1 ? cur+1  : -1,
        y > 0    ? cur-LW : -1,
        y < LH-1 ? cur+LW : -1
      ];
      for (var j = 0; j < 4; j++) {
        if (ns[j] >= 0 && dist[ns[j]] > nd) {
          dist[ns[j]] = nd;
          queue.push(ns[j]);
        }
      }
    }

    distField = dist;
  }

  // ── 프레임 렌더 ──────────────────────────────────────────
  function draw() {
    if (!svgReady)  { raf = requestAnimationFrame(draw); return; }
    if (!distField) { buildDF(); }

    var img = ctx.createImageData(LW, LH);
    var d   = img.data;

    for (var i = 0; i < LW * LH; i++) {
      var r = distField[i]; // 경계선까지의 거리

      // 여러 주파수 합성 → 간섭 무늬
      var v = Math.sin(r * 0.35 - t * 0.012)
            + Math.sin(r * 1.40 - t * 0.015) * 0.35
            + Math.sin(r * 0.32 + t * 0.008) * 0.40;
      var norm = Math.max(0, Math.min(1, (v + 1.95) / 3.9));

      var hue = (norm * 200 + t * 0.22) % 360;
      var sat = 0.20 + norm * 0.22;
      var lig = 0.18 + norm * 0.20;

      var rgb  = hsl(hue/360, sat, lig);
      var base = i * 4;
      d[base]   = rgb[0];
      d[base+1] = rgb[1];
      d[base+2] = rgb[2];
      d[base+3] = 255;
    }

    ctx.putImageData(img, 0, 0);
    t  += 1;
    raf = requestAnimationFrame(draw);
  }

  // ── 캔버스 크기 동기화 ───────────────────────────────────
  function syncSize() {
    W  = window.innerWidth;
    H  = window.innerHeight;
    LW = Math.max(1, Math.round(W / SCALE));
    LH = Math.max(1, Math.round(H / SCALE));
    canvas.width  = LW;
    canvas.height = LH;
    canvas.style.width  = W + 'px';
    canvas.style.height = H + 'px';
    if (svgReady) distField = null; // 리사이즈 시 재계산
  }

  // ── 활성화 / 해제 ────────────────────────────────────────
  function activate() {
    if (active) return;
    active = true;
    syncSize();
    overlay.classList.add('is-active');
    draw();
  }

  function dismiss() {
    if (!active) return;
    active = false;
    overlay.classList.remove('is-active');
    cancelAnimationFrame(raf);
    raf = null;
    scheduleIdle();
  }

  // ── 유휴 타이머 ──────────────────────────────────────────
  function scheduleIdle() {
    clearTimeout(idleTimer);
    idleTimer = setTimeout(activate, IDLE_MS);
  }

  function onActivity() {
    if (active) { dismiss(); return; }
    scheduleIdle();
  }

  // ── 초기화 ───────────────────────────────────────────────
  function init() {
    svgImg = new Image();
    svgImg.crossOrigin = 'anonymous';
    svgImg.onload = function () { svgReady = true; };
    svgImg.src = window.SUONO_SYMBOL_URL || '/assets/suono_symbol2.svg';

    overlay = document.createElement('div');
    overlay.id = 'suono-screensaver';

    canvas = document.createElement('canvas');
    ctx    = canvas.getContext('2d');
    overlay.appendChild(canvas);
    document.body.appendChild(overlay);

    overlay.addEventListener('click',      dismiss);
    overlay.addEventListener('touchstart', dismiss, { passive: true });

    ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click']
      .forEach(function (ev) {
        document.addEventListener(ev, onActivity, { passive: true });
      });

    window.addEventListener('resize', function () {
      if (active) syncSize();
    });

    scheduleIdle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
